import { render } from "./Stats.vue?vue&type=template&id=59341dca"
const script = {}
script.render = render

export default script